import client from './main-client';

export const fetchMunicipalityLeadsApi = (params) => client()
  .get(`leads?companyName=${params.companyName}&municipality=${params.municipality}&leadType=${params.leadType}`);
